import React from 'react';

const TrendSparkline = ({ points, color = '#0EA5E9', highlightIndex = -1, height: heightProp = 92 }) => {
  if (!points.length) return null;

  const width = 320;
  const height = heightProp;
  const padding = 12;
  const validPoints = points.filter((point) => typeof point.value === 'number');
  if (!validPoints.length) {
    return <div className="h-[92px] rounded-xl bg-slate-50 border border-dashed border-slate-200" />;
  }

  const values = validPoints.map((point) => point.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = points.length > 1 ? (width - padding * 2) / (points.length - 1) : 0;

  const normalized = points.map((point, index) => {
    const x = padding + index * stepX;
    if (typeof point.value !== 'number') {
      return { ...point, x, y: height / 2, missing: true };
    }
    const ratio = (point.value - min) / range;
    const y = height - padding - ratio * (height - padding * 2);
    return { ...point, x, y, missing: false };
  });

  const visiblePoints = normalized.filter((point) => !point.missing);
  const polylinePoints = visiblePoints.map((point) => `${point.x},${point.y}`).join(' ');

  const first = visiblePoints[0];
  const last = visiblePoints[visiblePoints.length - 1];
  const areaPoints = first && last
    ? `${first.x},${height - padding} ${polylinePoints} ${last.x},${height - padding}`
    : null;

  const gradId = `sg-${color.replace('#', '')}`;
  const glowId = `sg-glow-${color.replace('#', '')}`;

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="w-full" style={{ height: heightProp }} aria-hidden="true">
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.32" />
          <stop offset="50%" stopColor={color} stopOpacity="0.12" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
        <filter id={glowId} x="-10%" y="-10%" width="120%" height="120%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="2.5" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>
      <line x1={padding} y1={height - padding} x2={width - padding} y2={height - padding} stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
      {areaPoints && <polygon fill={`url(#${gradId})`} points={areaPoints} stroke="none" />}
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points={polylinePoints}
        filter={`url(#${glowId})`}
      />
      {normalized.map((point, index) => {
        const isHighlight = index === highlightIndex;
        return (
          <g key={`${point.label}-${index}`}>
            {isHighlight && (
              <circle cx={point.x} cy={point.y} r="9" fill="none" stroke={color} strokeWidth="1.5" opacity="0.3" />
            )}
            <circle
              cx={point.x}
              cy={point.y}
              r={isHighlight ? 5 : 2.5}
              fill={isHighlight ? 'white' : color}
              opacity={point.missing ? 0.2 : 1}
              stroke={isHighlight ? color : 'none'}
              strokeWidth={isHighlight ? 2 : 0}
            />
          </g>
        );
      })}
    </svg>
  );
};

export default TrendSparkline;

